import React from "react";
import "./skills.css";
import Stack from "./Stack";

const Skills = () => {
  return <Stack />;
};

export default Skills;
